import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/LandingClient.tsx");
